function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.295 20.06C15.295 20.06 17.2483 21.5877 19.7629 21.5877C22.2775 21.5877 33.2114 15.5771 36.3899 15.5771C39.5684 15.5771 41.6713 18.5824 41.6713 18.5824",
  stroke: "#FF543F",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.295 29.9776C15.295 29.9776 17.2483 31.5053 19.7629 31.5053C22.2775 31.5053 33.2114 25.4947 36.3899 25.4947C39.5684 25.4947 41.6713 28.5 41.6713 28.5",
  stroke: "#9972BB",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.295 39.8951C15.295 39.8951 17.2483 41.4228 19.7629 41.4228C22.2775 41.4228 33.2114 35.4122 36.3899 35.4122C39.5684 35.4122 41.6713 38.4175 41.6713 38.4175",
  stroke: "#4A90E2",
  strokeWidth: 2,
  strokeLinecap: "round"
});

function SvgHvac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac);
export default __webpack_public_path__ + "static/media/HVAC.33af5ccc.svg";
export { ForwardRef as ReactComponent };